module.exports = __webpack_public_path__ + "media/106.c47db790.mp3";